import { POST_CHECKPOINT } from "constants/api"
import axios, { AxiosError } from "axios"
import ErrorView from "components/error-view"
import ExchangeComponent from "components/exchange"
import LoadingScreen from "components/loading-screen"
import { useSession } from "contexts/session-context"
import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { Prize } from "views/prizes/types"
import textServices from "services/text-services"
import { dlTrackEvent } from "components/dataLayer/dataLayer"

interface IProps {
  id: string
}

export default function CheckpointPrize({ id }: IProps) {
  const [{ data: session }] = useSession()
  const history = useHistory()
  const [prize, setPrize] = useState<Prize>()
  const [error, setError] = useState<number>()
  const [isEmptyResult, setIsEmptyResult] = useState<boolean>(false)

  const handler = async () => {
    try {
      const { data } = await axios.post(
        POST_CHECKPOINT,
        null,
        {
          params: { checkpointId: id },
          headers: { Authorization: `Bearer ${((session as any)?._tokenResponse as any).idToken}`, 'Ph-Api-Id': PH_API_ID ?? 1 }
        }
      )

      const isEmpty = !data || Object.keys(data).length === 0
      setIsEmptyResult(isEmpty)

      dlTrackEvent('user_interaction', {
        action: 'click',
        element: 'redeemed checkpoint',
        section: `checkpoint`
      })

      let prize = {
        couponTypeId: data?.couponTypeId,
        title: '',
        points: data?.points,
        imageUrl: data?.imageUrl,
        stickerId: data?.stickerId,
        prizeNumber: 0
      } as any

      if (data?.product) {
        prize = {
          ...data?.product,
          couponTypeId: data?.couponTypeId
        }
      }

      if (!data?.product && data?.couponTypeId === 4) {
        prize.imageUrl = `${AZURE_BASE_URL}/img_no_ganaste.webp`
      }

      setPrize(prize)
    } catch (error) {
      gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'Checkpoint - Ingreso érroneo', value: '10' })
      const err = error as AxiosError
      const code = err.response?.data.code || 99999
      setError(code)
    }
  }

  useEffect(() => {
    if (session) {
      handler()
    }
  }, [])

  if (error) {
    return (
      <ErrorView
        code={error}
        buttonMenu={() => history.push('/home')}
        onRetry={() => history.push('/home')}
      />
    )
  }

  if (prize) {
    return (
      <ExchangeComponent
        title={isEmptyResult ? "Gracias" : undefined}
        description={isEmptyResult ? "Ya estás participando" : undefined}
        buttons={{
          handleMenu() { history.push(textServices?.findByText('checkpoint/prize/buttonUrl', '/home')) },
          handleButtonCommon() { history.push(textServices?.findByText('checkpoint/prize/buttonUrl', '/home')) },
          handleButtonSticker() { history.push(textServices?.findByText('checkpoint/prize/buttonUrl', '/home')) },
          text: textServices?.findByText('checkpoint/prize/button', { es: 'VOLVER A LA HOME', en: 'BACK TO HOME' })
        }}
        item={prize}
        module="checkpoint"
      />
    )
  }

  return <LoadingScreen />
}